/*eslint-disable react/no-danger*/
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';

import { getChatState, getChatQueueRejection, getF2F } from 'selectors';
import Link from 'components/Link';
import Button from 'components/Button';
import * as actions from 'actions';
import './style.scss';

class ChatState extends Component {

  constructor() {
    super();

    this.handleEnqueue = this.handleEnqueue.bind(this);
    this.handleEnqueueCancel = this.handleEnqueueCancel.bind(this);
    this.handleStartChat = this.handleStartChat.bind(this);
  }

  componentDidMount() {
    if (this.props.onDidMount) {
      this.props.onDidMount();
    }
  }

  handleEnqueue(event) {
    event.preventDefault();
    this.props.onEnqueue();
  }

  handleEnqueueCancel(event) {
    event.preventDefault();
    this.props.onEnqueueCancel();
  }

  handleStartChat(event) {
    event.preventDefault();
    this.props.onStartChat();
  }

  render() {
    let title;
    let subTitle;
    let icon;
    let button;

    const incrisisLink = `${process.env.KOOTH_UNAUTH_URL}/incrisis.html`;
    const hasStartedScheduledChatSession = (
      this.props.scheduledChatSessionStartDate !== undefined &&
      this.props.scheduledChatSessionStartDate.diff(moment()) < 0
    );

    if(this.props.isRejectedFromQueue) {
      title = <h4>{__('members.chat.state.rejected.title')}</h4>;
      subTitle = <p>{this.props.queueRejectionReason} <br /><br /> {__('members.chat.state.rejected.timeToWait')} {moment(this.props.queueRejectionExpiritationDate).from()}.</p>;
      icon = (
        <div className="mark-chat-state">
          <img src={__('members.chat.stateIconUrl')} />
          <div className="color" />
        </div>
      );
      button = process.env.FEATURES.mail === true ? <Button isYellow to="/messages/new">{__('members.chat.state.rejected.button')}</Button> : '';
    }
    else if(this.props.state === 'OFFLINE') {
      title = <h4 dangerouslySetInnerHTML={{ __html: __('members.chat.state.offline.title') }} />;
      subTitle = <p dangerouslySetInnerHTML={{ __html: `You can send a message below and we will respond later or if you need urgent help you can contact one of <a class='Link' target='_blank' href=${incrisisLink}>these organisations</a>.` }} />;
      icon = (
        <div className="mark-chat-state">
          <img src={__('members.chat.stateIconUrl')} />
          <div className="color" />
        </div>
      );
      button = process.env.FEATURES.mail === true ? <Button isYellow to="/messages/new">{__('members.chat.state.offline.button')}</Button> : '';
    }
    else if(this.props.state === 'ACTIVE_NOT_STARTED') {
      title = <h4>{__('members.chat.state.activeNotStarted.title')}</h4>;
      icon = (
        <div className="mark-chat-state">
          <img src={__('members.chat.stateIconUrl')} />
          <div className="color is-ready">
            <span className="icon-checkmark" />
          </div>
        </div>
      );
      button = <Button isGreen hasIcon iconType="checkmark" hasIconAnimated onClick={this.handleStartChat}>{__('members.chat.state.activeStarted.button')}</Button>;
    }
    else if(this.props.state === 'ACTIVE_STARTED') {
      title = <h4>{__('members.chat.state.activeStarted.title')}</h4>;
      icon = (
        <div className="mark-chat-state">
          <img src={__('members.chat.stateIconUrl')} />
          <div className="color is-ready" />
        </div>
      );
      button = <Button isGreen onClick={this.handleStartChat}>{__('members.chat.state.activeStarted.button')}</Button>;
    }
    else if(this.props.state === 'WAITING_TO_CANCEL_ENQUEUE' || this.props.state === 'QUEUED') {
      title = <h4 dangerouslySetInnerHTML={{ __html: __('members.chat.state.waiting.title') }} />;
      subTitle = <p>{__('members.chat.state.waiting.subtitle')}</p>;
      icon = (
        <div className="mark-chat-state">
          <img src={__('members.chat.stateIconUrl')} />
          <div className="color is-loading">
            <span className="icon-preloader" />
          </div>
        </div>
      );
      button = <Button isBlue hasIcon iconType="preloader" hasIconAnimated onClick={this.handleEnqueueCancel} isDisabled={this.props.state === 'WAITING_TO_CANCEL_ENQUEUE'}>{__('members.chat.state.waiting.button')}</Button>;
    }
    else if (hasStartedScheduledChatSession) {
      title = <h4>{__('members.chat.state.scheduled.title')}</h4>;
      subTitle = __('members.chat.state.scheduled.subtitle') ? <p>{__('members.chat.state.scheduled.subtitle')}</p> : '';
      icon = (
        <div className="mark-chat-state">
          <img src={__('members.chat.stateIconUrl')} />
          <div className="color" />
        </div>
      );
      button = <Button isGreen onClick={this.handleEnqueue} isDisabled={this.props.state === 'WAITING_TO_ENQUEUE'}>{__('members.chat.state.scheduled.button')}</Button>;
    }
    else if(this.props.state === 'ONLINE' || this.props.state === 'WAITING_TO_ENQUEUE') {
      title = <h4 dangerouslySetInnerHTML={{ __html: __('members.chat.state.online.title') }} />;
      subTitle = <p dangerouslySetInnerHTML={{ __html: `You can send a message below and we will respond later or if you need urgent help you can contact one of <a class='Link' target='_blank' href=${incrisisLink}>these organisations</a>.` }} />;
      icon = (
        <div className="mark-chat-state">
          <img src={__('members.chat.stateIconUrl')} />
          <div className="color" />
        </div>
      );
      button = <Button isGreen onClick={this.handleEnqueue} isDisabled={this.props.state === 'WAITING_TO_ENQUEUE'}>{__('members.chat.state.online.button')}</Button>;
    }

    const className = classnames('ChatState', {
      'is-online': this.props.state !== 'OFFLINE' && !this.props.isRejectedFromQueue
    });

    return (
      <div className={className}>
        {title}
        {subTitle}
        {icon}
        {button}

        {this.props.isF2FAvailable && <p><Link to="/referral">{__('members.chat.faceToFaceButton')}</Link></p>}
      </div>
    );
  }
}

ChatState.propTypes = {
  onDidMount: PropTypes.func,
  state: PropTypes.string,
  onEnqueue: PropTypes.func,
  onEnqueueCancel: PropTypes.func,
  onStartChat: PropTypes.func,
  isRejectedFromQueue: PropTypes.bool,
  queueRejectionReason: PropTypes.string,
  queueRejectionExpiritationDate: PropTypes.object,
  isF2FAvailable: PropTypes.bool,
  scheduledChatSessionStartDate: PropTypes.object
};

const mapStateToProps = (state) => {
  const queueRejection = getChatQueueRejection(state);

  return {
    state: getChatState(state).stringValue,
    isRejectedFromQueue: queueRejection.isRejected,
    queueRejectionReason: queueRejection.reason,
    queueRejectionExpiritationDate: queueRejection.expirationDate,
    isF2FAvailable: getF2F(state).isAvailable
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDidMount: () => {
      dispatch(actions.f2fStatusFetch());
    },
    onEnqueue: () => {
      dispatch(actions.chatEnqueue());
    },
    onEnqueueCancel: () => {
      dispatch(actions.chatEnqueueCancel());
    },
    onStartChat: () => {
      dispatch(actions.chatOpen());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatState);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadsList/ChatInfo/ChatState/index.js
 **/